import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import HeroSection from '../components/hero-section';
import { checkUserAuthenticated } from '../lib/actions/linkedin';
import { isValidVariant } from '../lib/config/ab-tests';

export default function HomePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [variant, setVariant] = useState<string | null>(null);

  useEffect(() => {
    const tokenFromUrl = searchParams.get('_token');

    // If we have a token from URL (after OAuth callback), check if user is authenticated
    if (tokenFromUrl) {
      checkUserAuthenticated(tokenFromUrl).then((isAuthenticated) => {
        if (isAuthenticated) {
          // User is logged in, redirect to profile
          navigate('/profile');
        }
      });
    }

    // Get and validate variant parameter
    const variantParam = searchParams.get('v');
    if (variantParam && isValidVariant(variantParam)) {
      setVariant(variantParam);
    }
  }, [searchParams, navigate]);

  return (
    <main>
      <HeroSection variant={variant} />
    </main>
  );
}
